import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from '../../shared/components/loading/loading.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../shared/services/auth.service';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [
    LoadingComponent,
    FooterComponent
  ],
  providers: [AuthService],
  exports: [
    CommonModule,
    LoadingComponent,
    FooterComponent,
    TranslateModule
  ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/app/modules/shared/shared.module.ts